/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useNotificationsStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '480px',
  },
  screenTitle: {
    marginBottom: '20px',
  },

  groupName: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    lineHeight: '20px',
    fontWeight: 'bold',
    margin: '5px 0',
  },
  notificationType: {
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  commonNotifications: {
    color: theme.palette.tertiary.main,
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 'bold',
  },
  notificationName: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  switchCell: {
    display: 'flex',
    justifyContent: 'center',
  },

  gridTwoSwitches: {
    display: 'grid',
    gridGap: '16px 32px',
    gridTemplateColumns: 'minmax(200px, 3fr) minmax(1px, auto) minmax(1px, auto)',
    alignItems: 'center',
    '& > $settingsDivider, & > $headingOffset': {
      gridColumn: '1 / span 3',
    },
  },
  settingsDivider: {
    margin: '6px 0',
    borderTop: '1px solid #EEEEEE',
  },
  headingOffset: {
    paddingTop: '5px',
  },
}));
